if ($(".id--17").length) {
  $("#vatId").attr("placeholder", "");
  var $checkoutInputs = $('.id--17 input[type="text"], .id--17 input[type="email"], .id--17 input[type="password"], .id--17 input[type="tel"]');
  $checkoutInputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  $checkoutInputs.on("click focus", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  if ($("#billFullName").val()) {
    $("#billFullName").closest(".form-group").addClass("focused");
    $("#billFullName").trigger("focus");
  }

  $checkoutInputs.on("blur", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $('.co-contact-information').closest(".box").prepend(`
            <div class="customLogin">
              ${translation('customLoginText')}
              <span class="customLoginPopup">${translation('customLoginBtn')}</span>
        
            </div>
        `);

    $(".co-box.reg").prepend($("#set-registration").closest(".form-group"));
  }
}

if ($(".id--9").length) {
  if (!$("footer#footer").length) {
    $(document).ready(function () {
      if (sessionStorage.loadedFooter) {
        $(".overall-wrapper").append('<footer id="footer">' + sessionStorage.loadedFooter + "</footer>");

        $(".top-navigation-bar .container").prepend($("#footer .topUsps").clone());
      } else {
        $.ajax({
          type: "GET",
          dataType: "html",
          timeout: 1e4,
          cache: !0,
          url: "/",
          success: function (e) {
            var a = shoptet.common.createDocumentFromString(e),
              t = $(a).find("footer#footer").html();
            null !== t && $(".overall-wrapper").append('<footer id="footer">' + t + "</footer>");
            sessionStorage.loadedFooter = $("footer#footer").html();

            $(".top-navigation-bar .container").prepend($("#footer .topUsps").clone());
          },
        });
      }
    });
  }

  $(document).ready(function () {
    emptyCart();
  });
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    emptyCart();
  });
  function emptyCart() {
    if ($(".cart-empty").length) {
      $("body").addClass("cartEmpty");
      $(".cart-heading").before('<div class="imgBox"></div>');
      $('<div class="text-center"><a href="/" class="btn btn-conversion">'+translation('vybrat')+'</a></div>').appendTo(".cart-empty");
    }
  }
}

$("html").on("click", ".customLoginPopup", function () {
  $("body").addClass("user-action-visible login-window-visible");
});

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));

  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());

  $.get("/action/Cart/GetCartContent/?orderingProcessActive=1", function (data) {
    $('.cart-item[data-micro="cartItem"]').each(function () {
      get_id = $(this).attr("data-micro-sku");
      var $row = $(this);
      link = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image a')
        .attr("href");
      image = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image img')
        .attr("data-src")
        .replace("related", "detail");
      if (!$(this).find(".right").length) {
        $(this).wrapInner('<div class="right"></div>');
        $(this).prepend('<div class="image"><a href="' + link + '"><img src="' + image + '" alt="' + $(this).find('a[data-testid="recapItemName"]').text() + '"></a></div>');
      }
    });
  });
}

if ($(".id--16").length) {
  $("#orderFormButton span").text(translation('pokracovatnaobjednvaku'));
}

function mhProductInfoMove() {
  if ($(".id--9").length) {
    if ($(".extra.delivery span .price-range").length) {
      $(".extra.delivery").append($(".extra.delivery span .price-range").clone());
    }

    $("tr.removeable").each(function () {
      $(this).find(".p-name").append($(this).find(".p-availability").clone());
      $(this).find(".p-total").append($(this).find(".p-price").clone());

      if ($(this).find(".p-name a.show-related").length) {
        $(this).find(".p-name .show-related").text(translation('nepotrebujete'));
      }
    });

    $(".summary-wrapper").after($(".next-step-back"));
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">${translation('produkt')}</th>
                <th class="avail">${translation('dostupnost')}</th>
                <th class="qty">${translation('pocet')}</th>
                <th class="unit">${translation('cenaZaKus')}</th>
                <th class="sale">${translation('sleva')}</th>
                <th class="total">${translation('celkem')}</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $("tr.removeable").each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find(".p-price .show-tooltip").attr("title") || $row.find(".p-price .show-tooltip").attr("data-original-title");
          console.log();
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(",", "."))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, "")) : 0;
          const finalPrice = parseInt($row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, ""));
          const quantity = parseInt($row.find("input.amount").val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find(".p-price").append(`
                    <span class="sale-percent">${percent}%</span>
                `);
          $row.find(".p-total").before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      } else {
        $row.find(".p-total").before('<td class="p-sale"></td>');
      }
    });

    if (totalSaved > 0) {
      $(".price-wrapper").append(`
            <span class="price-label price-secondary" style="color:#118819;">
            Ušetřili jste:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }
  } else {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">${translation('produkt')}</th>
                <th class="avail">${translation('dostupnost')}</th>
                <th class="qty">${translation('pocet')}</th>
                <th class="unit">${translation('cenaZaKus')}</th>
                <th class="total">${translation('celkem')}</th>
            </tr>
        </thead>
    `);
  }

  $("#discount-checkbox").on("change", function () {
    $(".discount-coupon").toggleClass("active", this.checked);
  });

  if ($(".discount-coupon .applied-coupon").length) {
    $(".discount-coupon").addClass("active");
    $("#discount-checkbox").prop("checked", true);
    $('input[data-testid="buttonRemoveDiscountCoupon"]').attr("value", translation('odebratkupon'));
  }
}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  mhProductInfoMove();
});

if ($(".id--15.in-dekujeme").length) {
  $("h1").text(translation("objednavkaPrijata"));

  $("h1").after(
    `<p>${translation("dekujemeZaObjednavku")}</p>`
  );

  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith(translation("jejiCislo"));

  $('.recapitulation-wrapper[data-testid="recapTable"]')
    .append('<div class="co-box co-extra"></div>');

  $(".co-box.co-extra").append(
    $('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])')
  );

  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);

    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");

      $row.append(
        `<td class="zdarma">
          <span>${translation("zdarma")}</span>
        </td>`
      );

      $row
        .find("strong.for-free")
        .text(translation("darekKObjednavce"));
    }

    const $cell = $row.find("td.p-quantity");

    if (!$cell.length) return;

    const total = parseFloat(
      $cell
        .find("strong")
        .text()
        .replace(/\s/g, "")
        .replace("Kč", "")
        .replace(",", ".")
    );

    $row.append(
      `<td class="pricePerSingle">
        <span>${total} ${translation("zaKus")}</span>
      </td>`
    );
  });
}
